var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationProvider", {
    attrs: { rules: "required", name: _vm.name },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ failed, errors }) {
          return [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _vm.label
                  ? _c("label", { staticClass: "form-control-label" }, [
                      _vm._v(_vm._s(_vm.label)),
                    ])
                  : _vm._e(),
                _c("multiselect", {
                  class: { "is-invalid": failed },
                  attrs: { options: _vm.sortedOption, label: "label" },
                  model: {
                    value: _vm.iValue,
                    callback: function ($$v) {
                      _vm.iValue = $$v
                    },
                    expression: "iValue",
                  },
                }),
                errors.length
                  ? _c("b-form-invalid-feedback", [
                      _vm._v(" " + _vm._s(errors[0]) + " "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }